module.exports = __webpack_public_path__ + "img/event_index.11a54d8f.png";